import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Offer: RouteRecordRaw = {
  name: "Offer管理",
  path: "/offer",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  meta: {
    key: "/offer"
  },
  children: [
    {
      name: "Offer列表",
      path: "offer-list",
      meta: {
        key: "/offer/offer-list",
        keepAlive: true
      },
      component: () =>
        import("@/views/OfferNew/OfferList/index.vue").catch(onError)
    }
  ]
};

export default Offer;
